import './PreparingNotice.css';

/**
 * Shown while session state resolves — either history is loading and a prior
 * transcript may be restoring (entry/reload), or a freshly-started session is
 * spinning up ("New session"). An indeterminate progress bar sweeps until the
 * console knows whether to restore a conversation or greet fresh, so the greeting
 * renders once (no premature greeting that swaps to "welcome back"). Replaced by
 * `useAgentChat` with the transcript or the greeting. `mode` picks the copy.
 */
export default function PreparingNotice({
  mode = 'restoring',
}: {
  mode?: 'restoring' | 'creating';
}) {
  const label = mode === 'creating' ? 'Creating session…' : 'Restoring your session…';
  return (
    <div className="om-prep" role="status" aria-live="polite">
      <div className="om-prep__label">{label}</div>
      <div className="om-prep__bar">
        <span className="om-prep__fill" />
      </div>
    </div>
  );
}
